import type { Country, Currency } from '../../../services/billing/billing.types';

// The country code is reference in intlTelInput plugin for flags
export const currencies: Record<Currency, { symbol: string; country: Country }> = {
  usd: { symbol: '$', country: 'us' },
  aud: { symbol: '$', country: 'au' },
  nzd: { symbol: '$', country: 'nz' },
  gbp: { symbol: '£', country: 'gb' },
  eur: { symbol: '€', country: 'eu' },
};

// I don't like this at all...
export const country2currency: Record<Country | string, Currency> = {
  us: 'usd',
  au: 'aud',
  nz: 'nzd',
  gb: 'gbp',
};
